function getUnisexGenderInput(root = document) {
  return (
    root.querySelector('input[type="checkbox"][data-gender-unisex]') ||
    [...root.querySelectorAll('input[type="checkbox"][name*="gender"]')].find(
      (input) => input.dataset.label?.toLowerCase() === 'unisex'
    ) ||
    null
  );
}

function isManOrWomanGenderInput(input) {
  const label = input.dataset.label?.toLowerCase();
  return label === 'man' || label === 'woman' || label === 'men' || label === 'women';
}

function applyUnisexGenderToUrl(url) {
  const allKeys = Array.from(new Set(url.searchParams.keys()));
  const genderKey = allKeys.find((k) => k.toLowerCase().includes('gender'));
  if (!genderKey) return;

  const unisexInput = getUnisexGenderInput();
  const unisexValue = unisexInput?.value;
  if (!unisexValue) return;

  const values = url.searchParams.getAll(genderKey);
  const hasUnisex = values.includes(unisexValue);
  const manOrWomanValues = [...document.querySelectorAll(`input[type="checkbox"][name="${CSS.escape(genderKey)}"]`)]
    .filter((input) => isManOrWomanGenderInput(input))
    .map((input) => input.value);
  const hasManOrWomanSelected = values.some((value) => manOrWomanValues.includes(value));

  if (hasManOrWomanSelected && !hasUnisex) {
    url.searchParams.append(genderKey, unisexValue);
    history.replaceState(history.state, '', url.pathname + url.search);
  } else if (!hasManOrWomanSelected && hasUnisex) {
    url.searchParams.delete(genderKey);
    history.replaceState(history.state, '', url.pathname + url.search);
  }
}

function initGenderUnisexFilter() {
  // Horizon fires 'filter:update' synchronously AFTER pushState (URL already set)
  // but BEFORE sectionRenderer.renderSection() fetches the new HTML.
  // That window is where we add/remove Unisex via history.replaceState.
  document.addEventListener('filter:update', function () {
    applyUnisexGenderToUrl(new URL(window.location.href));
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initGenderUnisexFilter);
} else {
  initGenderUnisexFilter();
}
